import React, {Component} from 'react';
import '../src/scss/style.scss';
import MainWinners from "./components/sections/winners/mainWinners";


class App extends Component{
  render() {
    return (
        <>
          <MainWinners/>
         </>
  );
  }
  }


  export default App;
